






import { defineComponent, ref } from '@vue/composition-api'
import { getMyInsurancePolicies } from 'api/index'
import { GetMyInsurancePoliciesRes } from 'api/api-type'
import MyPolicyCard from '@/components/my-policy-card.vue'
import { omega } from '@didi/driver-biz-sdk'

export default defineComponent({
  components: {
    MyPolicyCard
  },
  setup() {
    const list = ref([] as unknown as GetMyInsurancePoliciesRes)
    getMyInsurancePolicies({
      insurance_id: 1100
    }).then((res) => {
      omega.trackEvent('wyc_c_insure_renxian_mypolicy_sw')
      list.value = res
    })
    return {
      list
    }
  }
})
